import angular from 'angular';
import linkedPercentageField from './linkedPercentageField';

export default angular
  .module('components.linkedPercentageField', [])
  .component('linkedPercentageField', linkedPercentageField).name;
